import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "kn-height-full detail-page-container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "p-d-flex p-jc-around" }
const _hoisted_4 = {
  ref: "document-execution-view",
  id: "document-execution-view",
  class: "p-d-flex p-flex-row myDivToPrint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentExecutionBreadcrumb = _resolveComponent("DocumentExecutionBreadcrumb")
  const _component_Button = _resolveComponent("Button")
  const _component_TieredMenu = _resolveComponent("TieredMenu")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Registry = _resolveComponent("Registry")
  const _component_Dossier = _resolveComponent("Dossier")
  const _component_Olap = _resolveComponent("Olap")
  const _component_DocumentExecutionSchedulationsTable = _resolveComponent("DocumentExecutionSchedulationsTable")
  const _component_KnParameterSidebar = _resolveComponent("KnParameterSidebar")
  const _component_DocumentExecutionHelpDialog = _resolveComponent("DocumentExecutionHelpDialog")
  const _component_DocumentExecutionRankDialog = _resolveComponent("DocumentExecutionRankDialog")
  const _component_DocumentExecutionNotesDialog = _resolveComponent("DocumentExecutionNotesDialog")
  const _component_DocumentExecutionMetadataDialog = _resolveComponent("DocumentExecutionMetadataDialog")
  const _component_DocumentExecutionMailDialog = _resolveComponent("DocumentExecutionMailDialog")
  const _component_DocumentExecutionLinkDialog = _resolveComponent("DocumentExecutionLinkDialog")
  const _component_DocumentExecutionSelectCrossNavigationDialog = _resolveComponent("DocumentExecutionSelectCrossNavigationDialog")
  const _component_DocumentExecutionCNContainerDialog = _resolveComponent("DocumentExecutionCNContainerDialog")
  const _component_DatasetEditorPreview = _resolveComponent("DatasetEditorPreview")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.embed && !_ctx.olapDesignerMode)
      ? (_openBlock(), _createBlock(_component_Toolbar, {
          key: 0,
          class: "kn-toolbar kn-toolbar--primary p-col-12"
        }, {
          start: _withCtx(() => [
            (_ctx.breadcrumbs.length > 1)
              ? (_openBlock(), _createBlock(_component_DocumentExecutionBreadcrumb, {
                  key: 0,
                  breadcrumbs: _ctx.breadcrumbs,
                  onBreadcrumbClicked: _ctx.onBreadcrumbClick
                }, null, 8, ["breadcrumbs", "onBreadcrumbClicked"]))
              : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.crossNavigationSourceDocumentName ? _ctx.crossNavigationSourceDocumentName : _ctx.document?.name), 1))
          ]),
          end: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              (_ctx.canEditCockpit && _ctx.documentMode === 'VIEW')
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-pencil",
                    class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                    onClick: _ctx.editCockpitDocumentConfirm
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.editCockpit'),
                      void 0,
                      { left: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (_ctx.canEditCockpit && _ctx.documentMode === 'EDIT')
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "fa fa-eye",
                    class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                    onClick: _ctx.editCockpitDocumentConfirm
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('documentExecution.main.viewCockpit'),
                      void 0,
                      { left: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_Button, {
                icon: "pi pi-refresh",
                class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                onClick: _ctx.refresh
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.refresh'),
                  void 0,
                  { left: true }
                ]
              ]),
              (_ctx.isParameterSidebarVisible)
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "fa fa-filter",
                    class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.parameterSidebarVisible = !_ctx.parameterSidebarVisible)),
                    "data-test": "parameter-sidebar-icon"
                  }, null, 512)), [
                    [
                      _directive_tooltip,
                      _ctx.$t('common.parameters'),
                      void 0,
                      { left: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_Button, {
                icon: "fa fa-ellipsis-v",
                class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                onClick: _ctx.toggle
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.menu'),
                  void 0,
                  { left: true }
                ]
              ]),
              _createVNode(_component_TieredMenu, {
                ref: "menu",
                model: _ctx.toolbarMenuItems,
                popup: true
              }, null, 8, ["model"]),
              (_ctx.isInDocBrowser())
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    icon: "fa fa-times",
                    class: "p-button-text p-button-rounded p-button-plain p-mx-2",
                    onClick: _ctx.closeDocumentConfirm
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('common.close'),
                      void 0,
                      { left: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loading || _ctx.loadingCrossNavigationDocument)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 1,
          class: "kn-progress-bar",
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (_ctx.parameterSidebarVisible)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            id: "document-execution-backdrop",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.parameterSidebarVisible = false))
          }))
        : _createCommentVNode("", true),
      (_ctx.filtersData && _ctx.filtersData.isReadyForExecution && !_ctx.loading && !_ctx.schedulationsTableVisible)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.mode === 'registry')
              ? (_openBlock(), _createBlock(_component_Registry, {
                  key: 0,
                  id: _ctx.urlData?.sbiExecutionId,
                  reloadTrigger: _ctx.reloadTrigger
                }, null, 8, ["id", "reloadTrigger"]))
              : (_ctx.mode === 'dossier')
                ? (_openBlock(), _createBlock(_component_Dossier, {
                    key: 1,
                    id: _ctx.document.id,
                    reloadTrigger: _ctx.reloadTrigger,
                    filterData: _ctx.filtersData
                  }, null, 8, ["id", "reloadTrigger", "filterData"]))
                : (_ctx.mode === 'olap')
                  ? (_openBlock(), _createBlock(_component_Olap, {
                      key: 2,
                      id: _ctx.urlData?.sbiExecutionId,
                      olapId: _ctx.document.id,
                      olapName: _ctx.document.label,
                      reloadTrigger: _ctx.reloadTrigger,
                      olapCustomViewVisible: _ctx.olapCustomViewVisible,
                      hiddenFormDataProp: _ctx.hiddenFormData,
                      onCloseOlapCustomView: _cache[3] || (_cache[3] = ($event: any) => (_ctx.olapCustomViewVisible = false)),
                      onApplyCustomView: _ctx.executeOlapCustomView,
                      onExecuteCrossNavigation: _ctx.executeOLAPCrossNavigation
                    }, null, 8, ["id", "olapId", "olapName", "reloadTrigger", "olapCustomViewVisible", "hiddenFormDataProp", "onApplyCustomView", "onExecuteCrossNavigation"]))
                  : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock("iframe", {
          key: index,
          ref: "documentFrame",
          name: 'documentFrame' + index,
          class: "document-execution-iframe"
        }, null, 8, ["name"])), [
          [_vShow, _ctx.mode === 'iframe' && _ctx.filtersData && _ctx.filtersData.isReadyForExecution && !_ctx.loading && !_ctx.schedulationsTableVisible && (item.label === _ctx.document.name || (_ctx.crossNavigationContainerData && index === _ctx.breadcrumbs.length - 1))]
        ])
      }), 128)),
      (_ctx.schedulationsTableVisible)
        ? (_openBlock(), _createBlock(_component_DocumentExecutionSchedulationsTable, {
            key: 2,
            id: "document-execution-schedulations-table",
            propSchedulations: _ctx.schedulations,
            onDeleteSchedulation: _ctx.onDeleteSchedulation,
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.schedulationsTableVisible = false))
          }, null, 8, ["propSchedulations", "onDeleteSchedulation"]))
        : _createCommentVNode("", true),
      (_ctx.parameterSidebarVisible)
        ? (_openBlock(), _createBlock(_component_KnParameterSidebar, {
            key: 3,
            class: "document-execution-parameter-sidebar kn-overflow-y",
            filtersData: _ctx.filtersData,
            propDocument: _ctx.document,
            userRole: _ctx.userRole,
            sessionEnabled: _ctx.sessionEnabled,
            dateFormat: _ctx.dateFormat,
            onExecute: _ctx.onExecute,
            onExportCSV: _ctx.onExportCSV,
            onRoleChanged: _ctx.onRoleChange,
            onParametersChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('parametersChanged', $event))),
            "data-test": "parameter-sidebar"
          }, null, 8, ["filtersData", "propDocument", "userRole", "sessionEnabled", "dateFormat", "onExecute", "onExportCSV", "onRoleChanged"]))
        : _createCommentVNode("", true),
      _createVNode(_component_DocumentExecutionHelpDialog, {
        visible: _ctx.helpDialogVisible,
        propDocument: _ctx.document,
        onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.helpDialogVisible = false))
      }, null, 8, ["visible", "propDocument"]),
      _createVNode(_component_DocumentExecutionRankDialog, {
        visible: _ctx.rankDialogVisible,
        propDocumentRank: _ctx.documentRank,
        onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rankDialogVisible = false)),
        onSaveRank: _ctx.onSaveRank
      }, null, 8, ["visible", "propDocumentRank", "onSaveRank"]),
      _createVNode(_component_DocumentExecutionNotesDialog, {
        visible: _ctx.notesDialogVisible,
        propDocument: _ctx.document,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.notesDialogVisible = false))
      }, null, 8, ["visible", "propDocument"]),
      _createVNode(_component_DocumentExecutionMetadataDialog, {
        visible: _ctx.metadataDialogVisible,
        propDocument: _ctx.document,
        propMetadata: _ctx.metadata,
        propLoading: _ctx.metadataLoading,
        onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.metadataDialogVisible = false)),
        onSaveMetadata: _ctx.onMetadataSave
      }, null, 8, ["visible", "propDocument", "propMetadata", "propLoading", "onSaveMetadata"]),
      _createVNode(_component_DocumentExecutionMailDialog, {
        visible: _ctx.mailDialogVisible,
        onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mailDialogVisible = false)),
        onSendMail: _ctx.onMailSave
      }, null, 8, ["visible", "onSendMail"]),
      _createVNode(_component_DocumentExecutionLinkDialog, {
        visible: _ctx.linkDialogVisible,
        linkInfo: _ctx.linkInfo,
        embedHTML: _ctx.embedHTML,
        propDocument: _ctx.document,
        parameters: _ctx.linkParameters,
        onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.linkDialogVisible = false))
      }, null, 8, ["visible", "linkInfo", "embedHTML", "propDocument", "parameters"]),
      _createVNode(_component_DocumentExecutionSelectCrossNavigationDialog, {
        visible: _ctx.destinationSelectDialogVisible,
        crossNavigationDocuments: _ctx.crossNavigationDocuments,
        onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.destinationSelectDialogVisible = false)),
        onSelected: _ctx.onCrossNavigationSelected
      }, null, 8, ["visible", "crossNavigationDocuments", "onSelected"]),
      (_ctx.crossNavigationContainerData)
        ? (_openBlock(), _createBlock(_component_DocumentExecutionCNContainerDialog, {
            key: 4,
            visible: _ctx.crossNavigationContainerVisible,
            data: _ctx.crossNavigationContainerData,
            onClose: _ctx.onCrossNavigationContainerClose
          }, null, 8, ["visible", "data", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.datasetPreviewShown)
        ? (_openBlock(), _createBlock(_component_DatasetEditorPreview, {
            key: 5,
            visible: _ctx.datasetPreviewShown,
            "prop-dataset": _ctx.datasetToPreview,
            "dashboard-id": _ctx.document.dashboardId,
            onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.datasetPreviewShown = false))
          }, null, 8, ["visible", "prop-dataset", "dashboard-id"]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}